module.exports = __webpack_public_path__ + "static/media/blueBankslip.595c6921.svg";